<!----
    Author: hjlee
    Description:
        리스트
---->
<template>
  <div v-if="haveLoaded && isVisible && hasAuthority('read_' + item) && (!slaveEvent || masterSelectedRow)" class="list-container">
    <div
      v-if="masterEvent"
      :class="{'disable-list-background': true, 'disabled': (slaveMode === 'create') || (slaveMode === 'update')}"
      v-html="$t('common.notification.slave_item_editing', { master_item: $t('item.nm.' + item), slave_item: $t('item.nm.' + slaveItem) })"
    />
    <div v-if="!developing" :class="{'working': mode === 'create' || mode === 'update'}">
      <div v-if="hasAuthority('read_' + item) && (mode === 'list')">
        <div class="card list-form">
          <div class="card-header">
            <i class="fa fa-list" /> {{ $t('item.nm.' + item) }} <span> - {{ $t('common.label.list') }} </span>
          </div>
          <div class="card-body show">
            <input style="display:none" type="text" name="faketextremembered">
            <input style="display:none" type="password" name="fakepasswordremembered">
            <b-container class="button-area">
              <b-button variant="light" @click="list">
                <i class="fa fa-refresh" />
              </b-button>
              <b-button v-if="isInsertable()" variant="light" @click="createRow">
                <i class="fa fa-plus" />
              </b-button>
              <b-button v-if="hasAuthority('delete_' + item) && deletable" variant="light" :disabled="selected.length === 0" @click="deleteRowsConfirm($event)">
                <i class="fa fa-trash-o" />
              </b-button>
            </b-container>
            <b-container class="search-area">
              <b-row align-h="end">
                <b-col
                  v-for="column in searchColumns"
                  :key="column.key"
                  xl="2"
                  lg="2"
                  md="3"
                  sm="3"
                  cols="12"
                >
                  <input style="display:none" type="text" name="faketextremembered">
                  <input style="display:none" type="password" name="fakepasswordremembered">
                  <b-form-input
                    v-if="column.search.type === 'text'"
                    v-model="column.searchValue"
                    :placeholder="column.label"
                    :name="column.key"
                    @change="onSearch()"
                  />
                  <b-form-select v-else-if="column.search.type === 'select'" v-model="column.searchValue" :options="getSearchSelectOptions(column)" @change="onSearch()" />
                </b-col>
              </b-row>
            </b-container>
            <div class="list-table-area">
              <div class="clear" />
              <b-table
                ref="table"
                striped
                hover
                :no-local-sorting="true"
                :busy="isBusy"
                :fields="listColumns"
                :items="rows"
                show-empty
                :checkable="checkable"
                :tbody-tr-class="tbodyTrRowClass"
                @sort-changed="sortingChanged"
                @row-clicked="onRowSelected"
              >
                <template slot="HEAD_check-area">
                  <b-form-checkbox v-model="allChecked" @change="toggleAllChecked()" />
                </template>
                <template slot="check-area" slot-scope="row">
                  <div v-b-tooltip.hover="!isDeletable(row.item)" :title="$t(getDeleteTooltip(row.item))">
                    <b-form-checkbox v-model="row.item.checked" :disabled="!isDeletable(row.item)" @change="checkRow(row.item)" />
                  </div>
                </template>
                <template slot="memo-area" slot-scope="row">
                  <memo-control
                    :memo-options="memoOptions"
                    :table-name="item"
                    :table-key="row.item[memoOptions.key]"
                    :collapse="true"
                    :floating="true"
                  />
                </template>
                <template slot="item-actions-area" slot-scope="row">
                  <div class="item-actions-container">
                    <div v-for="(control, controlIndex) in customItemActionControls" :key="controlIndex">
                      <b-button
                        :size="control.size?control.size:'sm'"
                        :variant="control.variant?control.variant:'secondary'"
                        @click="clickCustomItemAction(control, row)"
                      >
                        <i v-if="control.icon" :class="'icons fa fa-' + control.icon" /> &nbsp; {{ control.name }}
                      </b-button>
                    </div>
                    <div v-if="isAvailableRowAction('detail')">
                      <b-button size="sm" variant="info" type="button" @click="showRowDetail(row.item)">
                        <i class="icons fa fa-eye" /> &nbsp; {{ $t('common.button.show_detail') }}
                      </b-button>
                    </div>
                    <div v-if="isSelectable">
                      <b-button v-if="row.item === selectedRow" variant="secondary" size="sm" type="button" @click="onRowSelected(row.item)">
                        <i class="icons fa fa-hand-stop-o" /> &nbsp; {{ $t('common.button.hide_dependent_data') }}
                      </b-button>
                      <b-button v-else variant="secondary" size="sm" type="button" @click="onRowSelected(row.item)">
                        <i class="icons fa fa-hand-rock-o" /> &nbsp; {{ $t('common.button.show_dependent_data') }}
                      </b-button>
                    </div>
                    <div v-if="isAvailableRowAction('update') && row.item.isNewRevisionRequired" v-b-tooltip.hover="row.item.isMaxRevision" :title="!row.item.isMaxRevision?$t('common.error.most_recent_can_be_revised'):''">
                      <b-button variant="warning" size="sm" :disabled="!row.item.isMaxRevision" type="button" @click="createNewRevisionConfirm(row.item)">
                        <i class="icons fa fa-clone" /> &nbsp; {{ $t(infos.newRevisionButtonName) }}
                      </b-button>
                    </div>
                    <div v-else-if="isAvailableRowAction('update')" v-b-tooltip.hover="!isUpdatable(row.item)" :title="$t(getUpdateTooltip(row.item))">
                      <b-button variant="warning" :disabled="!isUpdatable(row.item)" size="sm" @click="updateRow(row.item)">
                        <i class="icons fa fa-pencil" /> &nbsp; {{ $t(updatable.buttonName) }}
                      </b-button>
                    </div>
                    <div v-if="isAvailableRowAction('delete')" v-b-tooltip.hover="!isDeletable(row.item)" :title="$t(getDeleteTooltip(row.item))">
                      <b-button size="sm" type="button" variant="danger" :disabled="!isDeletable(row.item)" @click="deleteRowsConfirm(undefined, row.item)">
                        <i class="icons fa fa-trash" /> &nbsp; {{ $t(deletable.buttonName) }}
                      </b-button>
                    </div>
                    <div class="down-arrow" />
                  </div>
                </template>
                <template v-for="(column, index) in listDataColumns" :slot="column.key" slot-scope="row">
                  <display-control
                    :key="index"
                    :name="column.key"
                    :text-infos="column.common?column.common.textInfos:undefined"
                    :separator-text-infos="column.common?column.common.separatorTextInfos:undefined"
                    :target-type="column.type"
                    :no-data-label-text-code="column.common?column.common.noDataLabelTextCode:undefined"
                    mode="list"
                    :is-html="column.isHtml"
                    :file-info="column.file"
                    :options="getSelectOptions(column)"
                    :value-key="getValueKey(column)"
                    :static-locale="column.inputControl ? column.inputControl.staticLocale : undefined"
                    :static-currency="column.inputControl ? column.inputControl.staticCurrency : undefined"
                    :type="column.inputControl && column.inputControl.type ? column.inputControl.type : undefined"
                    :type-code-field-name="column.inputControl && column.inputControl.typeCodeFieldName"
                    :title="column.label"
                    :contents="getContents(row.item, column.key)"
                    :visible-type="column.inputControl?column.inputControl.visibleType:undefined"
                    :visible-by="column.inputControl?column.inputControl.visibleBy:undefined"
                    :visible-data="row.item"
                    :master-selected-row="masterSelectedRow"
                  />
                  <memo-control
                    v-if="column.memoOptions"
                    :key="index"
                    :memo-options="column.memoOptions"
                    :table-name="item"
                    :table-key="row.item[column.memoOptions.key]"
                    :column-name="column.key"
                    :collapse="true"
                  />
                </template>
                <div slot="table-busy" class="text-center text-danger my-2">
                  <b-spinner class="align-middle" />
                  <strong>{{ $t('common.text.loading') }}</strong>
                </div>
                <template slot="empty">
                  <div class="no-data-text">
                    {{ $t('common.text.no_data') }}
                  </div>
                </template>
              </b-table>
            </div>
            <pig-tail-label v-for="(notification, notificationIndex) in notifications" :key="notificationIndex" :message="translateStringMapFromServer(notification)" />
            <b-pagination
              v-model="clickedPageNumber"
              align="center"
              :total-rows="totalElements"
              :per-page="size"
              @change="onPageChanged"
            />
          </div>
        </div>
      </div>
      <div v-else-if="hasAuthority('create_' + item) && (mode === 'create')">
        <div class="card insert-form">
          <div class="card-header">
            <i class="fa fa-edit" /> {{ $t('item.nm.' + item) }} <span> - {{ $t('common.label.insert') }}</span>
          </div>
          <div class="card-body show">
            <item-detail
              ref="insert-item-detail"
              :module="module"
              :infos="infos"
              :columns="insertColumns"
              action="insert"
              :item="item"
              :row="userInsertRow"
              :visible-data="userInsertRow"
              :master-selected-row="masterSelectedRow"
              @forceUpdate="onForceUpdate()"
            />
            <div class="form-actions">
              <button class="btn btn-primary" type="submit" @click="insertConfirm">
                {{ $t('common.button.insert') }}
              </button>
              <button class="btn btn-secondary" type="button" @click="cancelInsertion">
                {{ $t('common.button.cancel') }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="hasAuthority('read_' + item) && (mode === 'detail')">
        <div class="card detail-form">
          <div class="card-header">
            <i class="fa fa-edit" /> {{ $t('item.nm.' + item) }} <span> - {{ $t('common.label.detail') }}</span>
          </div>
          <div class="card-body show">
            <item-detail
              ref="detail-item-detail"
              :module="module"
              :infos="infos"
              :columns="detailColumns"
              action="detail"
              :item="item"
              :row="userDetailRow"
              :visible-data="userDetailRow"
              :master-selected-row="masterSelectedRow"
              @forceUpdate="onForceUpdate()"
            />
            <memo-control
              v-if="memoOptions"
              :memo-options="memoOptions"
              :table-name="item"
              :table-key="userDetailRow[memoOptions.key]"
              :collapse="memoOptions.collapse"
            />
            <div class="form-actions">
              <button class="btn btn-secondary" type="button" @click="toList">
                {{ $t('common.button.list') }}
              </button>
              <button v-if="updatable && userDetailRow.isNewRevisionRequired && userDetailRow.isMaxRevision" class="btn btn-primary" type="button" @click="createNewRevisionConfirm(userDetailRow)">
                {{ $t(infos.newRevisionButtonName) }}
              </button>
              <button v-if="updatable" :disabled="!isUpdatable(userDetailRow)" class="btn btn-primary" type="button" @click="updateRow(userDetailRow)">
                {{ $t(updatable.buttonName) }}
              </button>
              <button v-if="hasAuthority('delete_' + item) && deletable" :disabled="!isDeletable(userDetailRow)" class="btn btn-danger" type="button" @click="deleteRowsConfirm($event, userDetailRow)">
                {{ $t(deletable.buttonName) }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="hasAuthority('update_' + item) && (mode === 'update')">
        <div class="card update-form">
          <div class="card-header">
            <i class="fa fa-edit" /> {{ $t('item.nm.' + item) }} <span> - {{ $t('common.label.update') }}</span>
          </div>
          <div class="card-body show">
            <item-detail
              ref="update-item-detail"
              :module="module"
              :infos="infos"
              :columns="updateColumns"
              action="update"
              :item="item"
              :row="userUpdateRow"
              :visible-data="userUpdateRow"
              :master-selected-row="masterSelectedRow"
              @forceUpdate="onForceUpdate()"
            />
            <memo-control
              v-if="memoOptions"
              :memo-options="memoOptions"
              :table-name="item"
              :table-key="userUpdateRow[memoOptions.key]"
              :collapse="memoOptions.collapse"
            />
            <div class="form-actions">
              <button class="btn btn-primary" type="submit" @click="updateConfirm">
                {{ $t('common.button.save') }}
              </button>
              <button class="btn btn-secondary" type="button" @click="cancelUpdate">
                {{ $t('common.button.cancel') }}
              </button>
              <button v-if="hasAuthority('delete_' + item) && deletable" :disabled="!isDeletable(userUpdateRow)" class="btn btn-danger" type="button" @click="deleteRowsConfirm($event, userOriginalUpdateRow)">
                {{ $t(deletable.buttonName) }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <b-modal
        id="cancel-insertion-confirm-modal"
        ref="exitInsertionConfirmModalRef"
        :title="$t('common.modal.title.confirm')"
        :ok-title="$t('common.button.ok')"
        :cancel-title="$t('common.button.cancel')"
        :lazy="true"
        :no-close-on-backdrop="true"
        @ok="exitInsertion"
      >
        <p class="my-4" v-html="$t('common.modal.text.updated_confirm')" />
      </b-modal>
      <b-modal
        id="cancel-update-confirm-modal"
        ref="exitUpdateConfirmModalRef"
        :title="$t('common.modal.title.confirm')"
        :ok-title="$t('common.button.ok')"
        :cancel-title="$t('common.button.cancel')"
        :lazy="true"
        :no-close-on-backdrop="true"
        @ok="exitUpdate"
      >
        <p class="my-4" v-html="$t('common.modal.text.updated_confirm')" />
      </b-modal>
      <b-modal
        id="insert-confirm-modal"
        ref="insertConfirmModalRef"
        :title="$t('common.modal.title.confirm')"
        :ok-title="$t('common.button.ok')"
        :cancel-title="$t('common.button.cancel')"
        :lazy="true"
        :no-close-on-backdrop="true"
        @ok="insert"
      >
        <p class="my-4" v-html="$t('common.modal.text.insert_confirm')" />
      </b-modal>
      <b-modal
        id="update-confirm-modal"
        ref="updateConfirmModalRef"
        :title="$t('common.modal.title.confirm')"
        :ok-title="$t('common.button.ok')"
        :cancel-title="$t('common.button.cancel')"
        :lazy="true"
        :no-close-on-backdrop="true"
        @ok="update"
      >
        <p class="my-4" v-html="$t('common.modal.text.update_confirm')" />
      </b-modal>
      <b-modal
        id="create-revision-confirm-modal"
        ref="createRevisionConfirmModalRef"
        :title="$t('common.modal.title.confirm')"
        :ok-title="$t('common.button.ok')"
        :cancel-title="$t('common.button.cancel')"
        :lazy="true"
        :no-close-on-backdrop="true"
        @ok="createNewRevision"
      >
        <p class="my-4" v-html="$t('common.modal.text.create_new_revision_confirm')" />
      </b-modal>
      <b-modal
        id="delete-confirm-modal"
        ref="deleteConfirmModalRef"
        :title="$t('common.modal.title.confirm')"
        :ok-title="$t('common.button.ok')"
        :cancel-title="$t('common.button.cancel')"
        :lazy="true"
        :no-close-on-backdrop="true"
        @ok="deleteRows"
      >
        <p class="my-4" v-html="$t('common.modal.text.delete_confirm')" />
      </b-modal>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    module: {
      type: String,
      required: true
    },
    item: {
      type: String,
      required: true
    },
    slaveItem: {
      type: String,
      default: undefined
    },
    numbering: {
      type: Boolean,
      default: true
    },
    dontCheckAuthor: {
      type: Boolean,
      default: false
    },
    masterEvent: {
      type: String,
      default: undefined
    },
    slaveEvent: {
      type: String,
      default: undefined
    },
    listUrl: {
      type: String,
      default: undefined
    },
    createUrl: {
      type: String,
      default: undefined
    },
    detailUrl: {
      type: String,
      default: undefined
    },
    updateUrl: {
      type: String,
      default: undefined
    },
    createRevisionUrl: {
      type: String,
      default: undefined
    },
    deleteUrl: {
      type: String,
      default: undefined
    },
    listNotifications: {
      type: Array,
      default: undefined
    },
    customItemActionControls: {
      type: Array,
      default: undefined
    }
  },
  data: function() {
    return {
      developing: false,
      rows: [],
      isVisible: true,
      haveLoaded: false,
      listColumns: [], // 리스트용 컬럼 목록
      listDataColumns: [], // 리스트용 데이터 컬럼 목록(체크박스 등 추가 컬럼 제외)
      detailColumns: [], // 상세용 컬럼 목록
      insertColumns: [], // 입력용 컬럼 목록
      updateColumns: [], // 수정용 컬럼 목록
      totalColumns: [], // 전체 컬럼 목록
      searchQueries: [], // 검색 쿼리
      sortColumns: [],
      searchColumns: [],
      pageNumber: 0,
      clickedPageNumber: 1,
      size: 15,
      totalPages: 0,
      totalElements: 0,
      isBusy: true,
      searchTimer: undefined,
      mode: 'list',
      lastResponse: undefined,
      userInsertRow: {},
      userUpdateRow: {},
      userDetailRow: {},
      emptyRow: {},
      initialUpdateRow: {},
      checkable: false,
      showDetailAvailable: false,
      updatable: false,
      deletable: false,
      selected: [],
      allChecked: false,
      infos: {},
      keyColumns: [],
      slaveMode: 'list',
      scrollToMe: false,
      selectedRow: undefined, // 본 리스트에서 선택된 데이터
      masterSelectedRow: undefined, // 마스터에서 선택된 데이터
      notifications: [],
      memoConfigs: undefined // 메모 속성값들
    }
  },
  computed: {
    isSelectable() {
      return this.masterEvent
    }
  },
  watch: {
    selectedRow: function(newVal) {
      this.$emit('row-selected', {
        selectedRow: this.selectedRow
      })
      this.$nextTick(() => {
        if (this.masterEvent) {
          this.$eventHub.$emit(this.masterEvent, {
            name: 'masterRowSelected',
            selectedRow: this.selectedRow
          })
        }
      })
    }
  },
  mounted: function() {
    if (this.masterEvent) {
      this.$eventHub.$on(this.masterEvent, this.onMasterEvent)
    }
    if (this.slaveEvent) {
      this.$eventHub.$on(this.slaveEvent, this.onSlaveEvent)
    }
    if (!this.slaveEvent) {
      this.list()
    }
    this.$eventHub.$on('refreshAll', this.refreshAll)
    this.$forceUpdate()
  },
  beforeDestroy: function() {
    if (this.masterEvent) {
      this.$eventHub.$off(this.masterEvent, this.onMasterEvent)
    }
    if (this.slaveEvent) {
      this.$eventHub.$off(this.slaveEvent, this.onSlaveEvent)
    }
    this.$eventHub.$off('refreshAll', this.refreshAll)
  },
  methods: {
    refreshAll() {
      if (this.mode === 'list') {
        this.list()
      } else if (this.mode === 'detail') {
        this.showRowDetail(this.currentDetailRow)
        this.reserveRefresh = true
      } else {
        this.reserveRefresh = true
      }
    },
    getName(encoded) {
      if (!encoded) {
        return ''
      }
      const names = encoded.split(';')
      let ret = ''
      for (let i = 0; i < names.length; i++) {
        if (ret) {
          ret += ' '
        }
        ret += decodeURIComponent(names[i])
      }
      return ret
    },
    clickCustomItemAction(control, row) {
      this.$emit(control.event, row.item)
    },
    createNewRevisionConfirm(row) {
      this.newRevisionBaseRow = row
      this.showModal('createRevisionConfirmModalRef')
    },
    createNewRevision() {
      const row = this.newRevisionBaseRow
      this.isBusy = true
      let createRevisionUrl
      if (this.createRevisionUrl) {
        createRevisionUrl = this.createRevisionUrl
      } else {
        createRevisionUrl =
          this.module + '/manage/revision/' + this.item.toCamelCase()
      }

      if (createRevisionUrl.indexOf('?') >= 0) {
        createRevisionUrl += '&'
      } else {
        createRevisionUrl += '?'
      }
      createRevisionUrl += this.getMenuAliasQuery()
      this.$axios
        .$put(createRevisionUrl, row, { dont_hide_processing: true })
        .then(response => {
          this.isBusy = false
          if (response.resultCode === 'success') {
            this.$toast.info(this.$t(response.message, response.params))
            this.setMode('list')
            this.list()
          } else {
            console.error(this.$t(response.message, response.params))
            this.$toast.error(this.$t(response.message, response.params))
          }
        })
        .catch(() => {
          this.isBusy = false
        })
    },
    isInsertable() {
      if (!this.hasAuthority('create_' + this.item)) {
        return false
      }
      if (
        this.masterSelectedRow &&
        this.masterSelectedRow.isNewRevisionRequired
      ) {
        return false
      }
      if (this.insertColumns && this.insertColumns.length > 0) {
        return true
      }
      if (
        this.infos &&
        this.infos.additionalFieldInfoData &&
        this.infos.additionalFieldInfoData.insertable
      ) {
        return true
      }
      return false
    },
    isExcept(row, info) {
      let isExcept = false
      if (info) {
        isExcept = true
        const excepts = info.excepts
        if (excepts) {
          for (let i = 0; i < excepts.length; i++) {
            const except = excepts[i]
            let val = row[except.key]
            if (row[except.key + '_original_data']) {
              val = row[except.key + '_original_data']
            }
            if (except.key) {
              if (except.valueType === 'static_value') {
                if (except.values.indexOf(val) >= 0) {
                  isExcept = false
                  break
                }
              } else if (except.valueType === 'session') {
                for (let j = 0; j < except.values.length; j++) {
                  const value = except.values[j]
                  if (this.loggedInUser[value] === val) {
                    isExcept = false
                    break
                  }
                }
                if (!isExcept) {
                  break
                }
              }
            }
          }
        }
      }
      return isExcept
    },
    getTooltipForManipulate(row, info) {
      let tooltip
      if (info) {
        const excepts = info.excepts
        if (excepts) {
          for (let i = 0; i < excepts.length; i++) {
            const except = excepts[i]
            let val = row[except.key]
            if (row[except.key + '_original_data']) {
              val = row[except.key + '_original_data']
            }
            if (except.key) {
              if (except.valueType === 'static_value') {
                if (except.values.indexOf(val) >= 0) {
                  tooltip = except.tooltip
                  break
                }
              } else if (except.valueType === 'session') {
                for (let j = 0; j < except.values.length; j++) {
                  const value = except.values[j]
                  if (this.loggedInUser[value] === val) {
                    tooltip = except.tooltip
                    break
                  }
                }
                if (tooltip) {
                  break
                }
              }
            }
          }
        }
      }
      return tooltip
    },
    isDeletable(row) {
      if (
        this.masterSelectedRow &&
        this.masterSelectedRow.isNewRevisionRequired
      ) {
        return false
      }
      if (row.isNewRevisionRequired) {
        return false
      }
      return this.isExcept(row, this.infos.deletable)
    },
    getDeleteTooltip(row) {
      if (row && row.cannotUpdateOrDeleteNotification) {
        return row.cannotUpdateOrDeleteNotification
      }
      return this.getTooltipForManipulate(row, this.infos.deletable)
    },
    isUpdatable(row) {
      if (
        this.masterSelectedRow &&
        this.masterSelectedRow.isNewRevisionRequired
      ) {
        return false
      }
      if (row && row.cannotUpdateOrDeleteNotification) {
        return false
      }
      return this.isExcept(row, this.infos.updatable)
    },
    getUpdateTooltip(row) {
      if (row && row.cannotUpdateOrDeleteNotification) {
        return row.cannotUpdateOrDeleteNotification
      }
      return this.getTooltipForManipulate(row, this.infos.updatable)
    },
    onMasterEvent(event) {
      if (event.name === 'slaveModeChanged') {
        this.onSlaveModeChanged(event.mode)
      }
    },
    onSlaveEvent(event) {
      if (event.name === 'masterRowSelected') {
        this.onMasterRowSelected(event.selectedRow)
      }
    },
    onMasterRowSelected(row) {
      this.scrollToMe = false
      if (!this.masterSelectedRow && row) {
        this.scrollToMe = true
      }
      this.masterSelectedRow = row
      if (this.masterSelectedRow) {
        this.searchColumns = []
        this.pageNumber = 0
        this.list()
        this.setMode('list')
      } else {
        this.$forceUpdate()
      }
    },
    onSlaveModeChanged(slaveMode) {
      this.slaveMode = slaveMode
      if (this.slaveEvent) {
        this.$eventHub.$emit(this.slaveEvent, {
          name: 'slaveModeChanged',
          mode: slaveMode
        })
      }
      this.$forceUpdate()
    },
    onRowSelected(row) {
      if (this.isSelectable) {
        if (this.selectedRow === row) {
          this.selectedRow = undefined
        } else {
          this.selectedRow = row
        }

        this.$forceUpdate()
      }
    },
    tbodyTrRowClass(row) {
      let classes = ''
      if (this.selectedRow === row) {
        classes += 'selected-row'
      }
      if (this.isSelectable && this.rows && this.rows.length > 0) {
        classes += ' clickable nonopacity'
      }
      return classes
    },
    getKeys(row) {
      const keys = {}
      for (let i = 0; i < this.keyColumns.length; i++) {
        const keyColumn = this.keyColumns[i]
        if (row[keyColumn.key]) {
          keys[keyColumn.key] = row[keyColumn.key]
        }
      }
      return keys
    },
    async showRowDetail(row) {
      if (row !== this.selectedRow) {
        this.selectedRow = undefined
      }
      this.currentDetailRow = row
      const userDetail = await this.loadDetail(this.getKeys(row))
      if (userDetail) {
        if (userDetail.charsts) {
          for (const key in userDetail.charsts) {
            for (let i = 0; i < userDetail.charsts[key].length; i++) {
              const message = userDetail.charsts[key][i]
              this.setI18nMessage(
                message.locale.locale,
                message.code,
                message.charst
              )
            }
          }
        }
        this.detailColumns = window.copyObject(userDetail.columns)
        if (this.detailColumns.length > 0) {
          this.makeLabels(this.detailColumns)
          for (let i = this.detailColumns.length - 1; i >= 0; i--) {
            if (!this.detailColumns[i].detail) {
              this.detailColumns.splice(i, 1)
              continue
            }
          }

          this.userDetailRow = userDetail.contents
          if (this.infos.additionalFieldInfoData) {
            this.initAdditionalFieldData(
              this.userDetailRow,
              this.infos.additionalFieldInfoData
            )
          }
          if (this.infos.additionalFieldInfoSampleData) {
            this.initAdditionalFieldSampleData(
              this.userDetailRow,
              this.infos.additionalFieldInfoSampleData
            )
          }
        }
        this.showDetail()
      }
    },
    loadDetail(keys) {
      let detailUrl
      if (this.detailUrl) {
        detailUrl = this.detailUrl
      } else {
        detailUrl = this.module + '/manage/detail/' + this.item.toCamelCase()
      }

      if (detailUrl.indexOf('?') >= 0) {
        detailUrl += '&'
      } else {
        detailUrl += '?'
      }
      detailUrl += this.getMenuAliasQuery() + '&'
      return this.$axios
        .$get(detailUrl + this.serialize(keys))
        .then(response => {
          if (response.resultCode === 'success') {
            return response.data
          }
        })
    },
    loadUpdateRow(keys) {
      let updateUrl
      if (this.updateUrl) {
        updateUrl = this.updateUrl
      } else {
        updateUrl = this.module + '/manage/update/' + this.item.toCamelCase()
      }

      if (updateUrl.indexOf('?') >= 0) {
        updateUrl += '&'
      } else {
        updateUrl += '?'
      }
      updateUrl += this.getMenuAliasQuery() + '&'
      return this.$axios
        .$get(updateUrl + this.serialize(keys))
        .then(response => {
          if (response.resultCode === 'success') {
            return response.data
          }
        })
    },
    showDetail() {
      this.setMode('detail')
    },
    setMode(mode, cb) {
      if (mode === 'list' && this.reserveRefresh) {
        this.reserveRefresh = false
        this.list()
      }
      $(this.$el).css('opacity', 0)
      setTimeout(() => {
        this.mode = mode
        this.$nextTick(() => {
          $(this.$el).css('opacity', 1)
        })
        if (this.slaveEvent) {
          this.$eventHub.$emit(this.slaveEvent, {
            name: 'slaveModeChanged',
            mode: this.mode
          })
        }
        if (cb) {
          setTimeout(() => {
            cb()
          }, 400)
        }
      }, 300)
    },
    async updateRow(row) {
      if (row !== this.selectedRow) {
        this.selectedRow = undefined
      }
      const userUpdate = await this.loadUpdateRow(this.getKeys(row))
      if (userUpdate) {
        this.loadUpdate(userUpdate)

        if (this.slaveEvent) {
          for (let i = 0; i < this.totalColumns.length; i++) {
            const column = this.totalColumns[i]
            if (column.common && column.common.masterKey) {
              row[column.key] = this.masterSelectedRow
            }
          }
        }
        this.setMode('update')
      }
    },
    checkRow(row) {
      this.$nextTick(() => {
        let allChecked = true
        if (this.rows) {
          for (let i = 0; i < this.rows.length; i++) {
            if (!this.rows[i].checked) {
              allChecked = false
              break
            }
          }
        }
        if (this.selected.indexOf(row) < 0) {
          this.selected.push(row)
        } else {
          this.selected.splice(this.selected.indexOf(row), 1)
        }
        this.allChecked = allChecked
        this.$forceUpdate()
      })
    },
    toggleAllChecked() {
      let allChecked = true
      if (this.rows) {
        for (let i = 0; i < this.rows.length; i++) {
          if (!this.isDeletable(this.rows[i])) {
            continue
          }
          if (!this.rows[i].checked) {
            allChecked = false
            break
          }
        }
      }
      this.allChecked = !allChecked
      if (allChecked) {
        if (this.rows) {
          for (let i = 0; i < this.rows.length; i++) {
            if (!this.isDeletable(this.rows[i])) {
              continue
            }
            this.rows[i].checked = false
          }
        }
        this.selected = []
      } else {
        this.selected = []
        if (this.rows) {
          for (let i = 0; i < this.rows.length; i++) {
            if (!this.isDeletable(this.rows[i])) {
              continue
            }
            this.selected.push(this.rows[i])
            this.rows[i].checked = true
          }
        }
      }
      this.$forceUpdate()
    },
    onRefreshStrings() {
      this.draw()
      this.$forceUpdate()
    },
    createRow: function() {
      this.userInsertRow = this.initInsertRow(this.insertColumns)
      this.$nextTick(() => {
        this.setMode('create')
        if (this.isSelectable) {
          this.selectedRow = undefined
        }
        this.$nextTick(() => {
          this.emptyRow = window.copyObject(this.userInsertRow)
          this.$forceUpdate()
        })
      })
    },
    deleteRowsConfirm: function(e, item) {
      if (e) {
        e.stopPropagation()
        e.preventDefault()
      }
      this.deleteTarget = item
      this.showModal('deleteConfirmModalRef')
    },
    deleteRows: function() {
      this.isBusy = true

      let selectedRowContained = false

      const keys = []
      if (this.deleteTarget) {
        keys.push(this.getKeys(this.deleteTarget))
      } else if (this.mode === 'list') {
        for (let i = 0; i < this.selected.length; i++) {
          if (this.selected[i] === this.selectedRow) {
            selectedRowContained = true
          }
          const key = this.getKeys(this.selected[i])
          keys.push(key)
        }
      } else if (this.mode === 'detail') {
        selectedRowContained = true
        const key = this.getKeys(this.userDetailRow)
        keys.push(key)
      } else if (this.mode === 'update') {
        selectedRowContained = true
        const key = this.getKeys(this.userUpdateRow)
        keys.push(key)
      }

      let deleteUrl
      if (this.deleteUrl) {
        deleteUrl = this.deleteUrl
      } else {
        deleteUrl = this.module + '/manage/delete/' + this.item.toCamelCase()
      }
      if (deleteUrl.indexOf('?') >= 0) {
        deleteUrl += '&'
      } else {
        deleteUrl += '?'
      }
      deleteUrl += this.getMenuAliasQuery()
      this.$axios
        .$delete(deleteUrl, {
          data: keys,
          dont_hide_processing: true
        })
        .then(response => {
          this.isBusy = false
          if (response.resultCode === 'success') {
            this.$toast.info(this.$t(response.message, response.params))
            this.$emit('deleted', keys)
            if (selectedRowContained) {
              this.selectedRow = undefined
            }
            this.setMode('list')
            this.list()
          } else {
            console.error(this.$t(response.message, response.params))
            this.$toast.error(this.$t(response.message, response.params))
          }
        })
        .catch(() => {
          this.isBusy = false
        })
    },
    cancelInsertion: function() {
      window._eventHub.$emit('showLoading')
      if (
        !window.isObjectEquals(
          window.copyObjectWithoutOriginalData(this.userInsertRow),
          window.copyObjectWithoutOriginalData(this.emptyRow)
        )
      ) {
        this.showModal('exitInsertionConfirmModalRef')
        window._eventHub.$emit('hideLoading')
      } else {
        this.exitInsertion()
        window._eventHub.$emit('hideLoading')
      }
    },
    cancelUpdate: function() {
      window._eventHub.$emit('showLoading')

      if (!window.isObjectEquals(this.userUpdateRow, this.initialUpdateRow)) {
        this.showModal('exitUpdateConfirmModalRef')
        window._eventHub.$emit('hideLoading')
      } else {
        this.exitUpdate()
        window._eventHub.$emit('hideLoading')
      }
    },
    toList: function() {
      this.setMode('list', () => {
        this.userInsertRow = {}
      })
    },
    exitInsertion: function() {
      this.setMode('list', () => {
        this.userInsertRow = {}
      })
    },
    exitUpdate: function() {
      this.setMode('list', () => {
        this.userUpdateRow = {}
      })
    },
    onSearch: function() {
      if (this.searchTimer) {
        clearTimeout(this.searchTimer)
      }
      this.searchTimer = setTimeout(() => {
        this.pageNumber = 0
        this.search()
      }, 400)
    },
    search() {
      const searchColumns = this.searchColumns
      this.searchQueries = []
      for (let i = 0; i < searchColumns.length; i++) {
        if (searchColumns[i].searchValue) {
          this.searchQueries.push({
            key: searchColumns[i].key,
            value: searchColumns[i].searchValue
          })
        }
      }
      this.list()
    },
    sortingChanged: function(ctx) {
      if (ctx.sortBy) {
        this.sortColumns = [
          { key: ctx.sortBy, direction: ctx.sortDesc ? 'desc' : 'asc' }
        ]
      } else {
        this.sortColumns = []
      }
      this.list()
    },
    onPageChanged: function(clickedPageNumber) {
      if (clickedPageNumber === this.clickedPageNumber) {
        return
      }
      this.clickedPageNumber = clickedPageNumber
      this.pageNumber = this.clickedPageNumber - 1
      this.list()
    },
    draw: function() {
      if (!this.lastResponse) return
      const response = window.copyObject(this.lastResponse)
      this.rows = response.data.pageData.content
      this.totalColumns = response.data.columns
      this.memoOptions = response.data.memoOptions
      this.keyColumns = []

      this.makeLabels(this.totalColumns)

      for (let i = 0; i < this.totalColumns.length; i++) {
        const column = this.totalColumns[i]
        if (this.hasAuthority('read_' + this.item) && column.detail) {
          this.showDetailAvailable = true
        }
        if (column.primary) {
          this.keyColumns.push(column)
        }
      }

      this.listColumns = window.copyObject(this.totalColumns)
      this.insertColumns = window.copyObject(this.totalColumns)
      this.pageNumber = response.data.pageData.pageable.pageNumber
      this.totalPages = response.data.pageData.totalPages
      this.totalElements = response.data.pageData.totalElements

      if (this.hasAuthority('delete_' + this.item)) {
        this.deletable = response.data.infos.deletable
      } else {
        this.deletable = false
      }

      this.checkable = !!this.deletable

      if (this.hasAuthority('update_' + this.item)) {
        this.updatable = response.data.infos.updatable
      } else {
        this.updatable = false
      }

      this.infos = response.data.infos
      this.notifications = []
      if (this.listNotifications) {
        this.notifications = this.notifications.concat(this.listNotifications)
      }
      if (this.infos && this.infos.notifications) {
        this.notifications = this.notifications.concat(this.infos.notifications)
      }
      if (this.mode === 'create') {
        if (this.infos && this.infos.insertNotifications) {
          this.notifications = this.notifications.concat(
            this.infos.insertNotifications
          )
        }
      } else if (this.mode === 'update') {
        if (this.infos && this.infos.updateNotifications) {
          this.notifications = this.notifications.concat(
            this.infos.updateNotifications
          )
        }
      }
      const actions = []
      this.listDataColumns = []
      if (this.listColumns.length > 0) {
        for (let i = this.listColumns.length - 1; i >= 0; i--) {
          if (this.listColumns[i].primary) {
            this.keyColumns.push(this.listColumns[i])
          }
          if (!this.listColumns[i].list) {
            this.listColumns.splice(i, 1)
            continue
          }
          if (!this.isListVisibleColumn(this.listColumns[i])) {
            this.listColumns.splice(i, 1)
            continue
          }
        }
        this.listDataColumns = window.copyObject(this.listColumns)
      }
      if (this.insertColumns.length > 0) {
        for (let i = this.insertColumns.length - 1; i >= 0; i--) {
          if (!this.insertColumns[i].insert) {
            this.insertColumns.splice(i, 1)
            continue
          }
        }
      }
      if (this.updatable) {
        actions.push('update')
      }
      if (this.isSelectable) {
        actions.push('select')
      }
      if (this.deletable) {
        actions.push('delete')
      }
      if (this.showDetailAvailable) {
        actions.push('detail')
      }

      if (actions && actions.length > 0) {
        this.listColumns = [
          {
            key: 'item-actions-area',
            label: '',
            class: 'item-actions-area'
          }
        ].concat(this.listColumns)
      }
      if (this.memoOptions) {
        this.listColumns = [
          {
            key: 'memo-area',
            label: '',
            class: 'memo-area'
          }
        ].concat(this.listColumns)
      }
      this.rowActions = actions
      if (this.numbering) {
        this.listColumns = [
          {
            key: '_no',
            label: '#',
            class: 'numbering-area'
          }
        ].concat(this.listColumns)
      }
      if (this.checkable) {
        this.listColumns = [
          {
            key: 'check-area'
          }
        ].concat(this.listColumns)
      }

      if (this.rows) {
        for (let i = 0; i < this.rows.length; i++) {
          if (this.numbering) {
            this.rows[i]._no =
              this.totalElements - i - this.size * this.pageNumber
          }
        }
      }
      if (!this.searchColumns || this.searchColumns.length === 0) {
        this.searchColumns = []
        for (let i = 0; i < this.totalColumns.length; i++) {
          if (this.totalColumns[i].search) {
            this.totalColumns[i].searchValue = ''
            this.searchColumns.push(this.totalColumns[i])
          }
        }
      }
    },
    list: function(remainSelected) {
      this.isBusy = true
      if (remainSelected && this.selectedRow) {
        this.oldSelectedId = this.selectedRow.id
      } else if (this.isSelectable) {
        this.selectedRow = undefined
      }
      let listUrl
      if (this.listUrl) {
        listUrl = this.listUrl
      } else {
        listUrl = this.module + '/manage/list/' + this.item.toCamelCase()
      }

      if (listUrl.indexOf('?') >= 0) {
        listUrl += '&'
      } else {
        listUrl += '?'
      }
      listUrl += this.getMenuAliasQuery()
      this.allChecked = false

      this.$axios
        .$post(listUrl, {
          sortColumns: this.sortColumns,
          searchQueries: this.searchQueries,
          size: this.size,
          pageNumber: this.pageNumber,
          masterSelectedRow: this.masterSelectedRow
        })
        .then(response => {
          this.isBusy = false
          this.haveLoaded = true
          if (response.resultCode === 'success') {
            if (
              this.item === 'site' &&
              this.searchQueries.length === 0 &&
              response.data &&
              response.data.pageData &&
              response.data.pageData.content &&
              response.data.pageData.content.length === 1
            ) {
              if (!this.selectedRow) {
                this.onRowSelected(response.data.pageData.content[0])
                this.isVisible = false
              }
            }
            this.lastResponse = response
            this.selected = []
            this.draw()
            if (this.scrollToMe) {
              this.$nextTick(() => {
                $('.app-body').animate(
                  {
                    scrollTop:
                      $(this.$el).offset().top -
                      55 +
                      $('.app-body').scrollTop() +
                      'px'
                  },
                  'ease-in'
                )
              })
              this.scrollToMe = false
            }
          } else {
            console.error(this.$t(response.message, response.params))
            this.$toast.error(this.$t(response.message, response.params))
          }
          if (remainSelected && this.oldSelectedId && this.rows) {
            for (let i = 0; i < this.rows.length; i++) {
              if (this.oldSelectedId === this.rows[i].id) {
                this.onRowSelected(this.rows[i])
                break
              }
            }
          }
        })
        .catch(() => {
          this.isBusy = false
          this.haveLoaded = true
        })
    },
    insert: function() {
      this.isBusy = true

      const userInsertRow = window.copyObject(this.userInsertRow)
      // 사전 처리
      for (let i = this.insertColumns.length - 1; i >= 0; i--) {
        if (this.insertColumns[i].inputControl.type === 'multiselect') {
          const key = this.insertColumns[i].key
          const values = []
          if (Array.isArray(userInsertRow[key])) {
            if (userInsertRow[key] && userInsertRow[key].length > 0) {
              for (let j = 0; j < userInsertRow[key].length; j++) {
                values.push(userInsertRow[key][j].value)
              }
            }
          } else if (userInsertRow[key]) {
            values.push(userInsertRow[key].value)
          }
          userInsertRow[key] = values
        }
      }
      let createUrl
      if (this.createUrl) {
        createUrl = this.createUrl
      } else {
        createUrl = this.module + '/manage/create/' + this.item.toCamelCase()
      }

      if (createUrl.indexOf('?') >= 0) {
        createUrl += '&'
      } else {
        createUrl += '?'
      }
      createUrl += this.getMenuAliasQuery()
      this.$axios
        .$post(createUrl, userInsertRow, { dont_hide_processing: true })
        .then(response => {
          this.isBusy = false
          if (response.resultCode === 'success') {
            this.$toast.info(this.$t(response.message, response.params))
            this.setMode('list')
            const data = response.data
            if (data && data.charsts) {
              for (let i = 0; i < data.charsts.length; i++) {
                let locale = data.charsts[i].locale
                if (locale && locale.locale) {
                  locale = locale.locale
                }
                this.setI18nMessage(
                  locale,
                  data.charsts[i].code,
                  data.charsts[i].charst
                )
              }
            }
            this.list()
            this.$emit('inserted', userInsertRow)
          } else {
            console.error(this.$t(response.message, response.params))
            this.$toast.error(this.$t(response.message, response.params))
          }
        })
        .catch(() => {
          this.isBusy = false
        })
    },
    async insertConfirm() {
      if (!(await this.validateUnder(this.$el, '.app-body'))) {
        return
      }
      window._eventHub.$emit('showLoading')

      this.showModal('insertConfirmModalRef')
    },
    async updateConfirm() {
      if (!(await this.validateUnder(this.$el, '.app-body'))) {
        return
      }
      window._eventHub.$emit('showLoading')
      if (!window.isObjectEquals(this.userUpdateRow, this.initialUpdateRow)) {
        this.showModal('updateConfirmModalRef')
      } else {
        this.exitUpdate()
        window._eventHub.$emit('hideLoading')
      }
    },
    update: function() {
      this.isBusy = true
      const userUpdateRow = window.copyObject(this.userUpdateRow)
      // 사전 처리
      for (let i = this.updateColumns.length - 1; i >= 0; i--) {
        if (this.updateColumns[i].inputControl.type === 'multiselect') {
          const key = this.updateColumns[i].key
          const values = []
          if (Array.isArray(userUpdateRow[key])) {
            for (let j = 0; j < userUpdateRow[key].length; j++) {
              values.push(userUpdateRow[key][j].value)
            }
          } else if (userUpdateRow[key]) {
            values.push(userUpdateRow[key].value)
          }

          userUpdateRow[key] = values
        }
      }
      let updateUrl
      if (this.updateUrl) {
        updateUrl = this.updateUrl
      } else {
        updateUrl = this.module + '/manage/update/' + this.item.toCamelCase()
      }

      if (updateUrl.indexOf('?') >= 0) {
        updateUrl += '&'
      } else {
        updateUrl += '?'
      }
      updateUrl += this.getMenuAliasQuery()
      this.$axios
        .$put(updateUrl, userUpdateRow, { dont_hide_processing: true })
        .then(response => {
          this.isBusy = false
          if (response.resultCode === 'success') {
            const data = response.data
            if (data && data.charsts) {
              for (let i = 0; i < data.charsts.length; i++) {
                let locale = data.charsts[i].locale
                if (locale && locale.locale) {
                  locale = locale.locale
                }
                this.setI18nMessage(
                  locale,
                  data.charsts[i].code,
                  data.charsts[i].charst
                )
              }
            }
            this.$toast.info(this.$t(response.message, response.params))
            this.setMode('list')
            this.list()
            this.$emit('updated', this.userUpdateRow)
          } else {
            console.error(this.$t(response.message, response.params))
            this.$toast.error(this.$t(response.message, response.params))
          }
        })
        .catch(() => {
          this.isBusy = false
        })
    }
  }
}
</script>

<style scoped>
>>> thead > tr > th[aria-sort] {
  padding-right: 1.125em;
}
>>> thead > tr > th[aria-sort]:after {
  box-sizing: border-box;
  float: right;
  display: block;
  padding-bottom: 0;
  margin-top: -3px;
  font-size: inherit;
  line-height: inherit;
  opacity: 0.4;
  content: '\2195';
  speak: none;
}
>>> thead > tr > th[aria-sort][aria-sort='descending']:after {
  opacity: 1;
  content: '\2191';
}
>>> thead > tr > th[aria-sort][aria-sort='ascending']:after {
  opacity: 1;
  content: '\2193';
}
>>> .page-item.disabled {
  display: none;
}

.button-area {
  margin-top: 20px;
  margin-bottom: 20px;
  max-width: 20%;
  overflow: hidden;
  float: left;
}
.search-area {
  margin-top: 20px;
  margin-bottom: 20px;
  max-width: 80%;
  overflow: hidden;
  float: right;
}
.search-area .row {
  margin-left: -30px;
  margin-right: -30px;
}
.form-control:focus {
  box-shadow: 0 0 0 0rem rgba(32, 168, 216, 0.25);
}
.custom-select:focus {
  box-shadow: 0 0 0 0rem rgba(32, 168, 216, 0.25);
}
.list-container {
  position: relative;
  transition: opacity 0.3s ease-in-out;
}
.no-data-text {
  text-align: center;
  margin-top: 50px;
  margin-bottom: 50px;
}
>>> .table td,
>>> .table th {
  white-space: nowrap !important;
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
}

>>> .table th {
  text-align: center;
}

.list-form,
.insert-form,
.update-form,
.detail-form {
  margin-top: 30px;
}

>>> .item-actions-area {
  padding: 0;
}
>>> .item-actions-area > .item-actions-container {
  margin-top: -40px;
  display: none;
  position: absolute;
  padding: 5px;
  border: 1px solid #dddddd;
  border-radius: 8px;
  background: white;
  z-index: 10;
  -webkit-box-shadow: 5px 5px 7px rgba(0, 0, 0, 0.3);
  -moz-box-shadow: 5px 5px 7px rgba(0, 0, 0, 0.3);
  box-shadow: 5px 5px 7px rgba(0, 0, 0, 0.3);
}
>>> .item-actions-area > .item-actions-container > .down-arrow {
  position: absolute;
  border-color: #ffffff transparent;
  border-style: solid;
  border-width: 10px 10px 0px 10px;
  margin-top: 30px;
  height: 0px;
  width: 0px;
}
>>> tr:hover .item-actions-area > .item-actions-container {
  display: block;
}
>>> .item-actions-container > div {
  float: left;
  margin-right: 5px;
}
>>> .item-actions-container > div:last-child {
  margin-right: 0px;
}
>>> a.clickable-column:hover {
  color: #167495;
  text-decoration: underline;
}

>>> a.clickable-column {
  color: #20a8d8;
  text-decoration: none;
  background-color: transparent;
  cursor: pointer;
}

.list-table-area {
  width: 100%;
  overflow-x: auto;
}

>>> td {
  text-align: center;
}

>>> .custom-checkbox {
  text-align: center;
}

>>> .numbering-area {
  text-align: center;
}

>>> .selected-row {
  background-color: #454599 !important;
  color: white !important;
}

.list-area {
  margin-top: 30px;
  border-top: 1px solid #aaaaaa;
}

.list-title {
  padding-top: 7px;
}

.disable-list-background {
  background-color: rgba(0, 0, 0, 0.8);
  text-align: center;
  padding-top: 50px;
  color: white;
  z-index: 2;
  display: none;
  position: absolute;
  width: 100%;
  height: 100%;
}
.disable-list-background.disabled {
  display: block;
}
.card-body {
  overflow: visible;
}
.form-actions {
  position: -webkit-sticky;
  position: sticky;
  bottom: 0;
  padding: 10px;
  background: white;
  border-radius: 5px;
  border: 1px solid #dddddd;
  float: right;
  z-index: 10;
}
>>> .nonopacity {
  opacity: 1 !important;
}
>>> .nonopacity:hover {
  opacity: 1 !important;
}
>>> .btn-info {
  color: white;
}
@media (max-width: 575px) {
  .button-area {
    max-width: 100% !important;
    width: 100% !important;
    float: none;
  }
  .search-area {
    max-width: 100% !important;
    width: 100% !important;
    float: none;
  }
}
</style>
